import React from 'react';

import { CentroCustoFormComp, CentroCustoListComp } from './components';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function CentroCustoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPLEMENTAR_CENTRO_DISTRIBUICAO_GERENCIAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <CentroCustoListComp />
        </ListagemProvider>
    );
}

export function CentroCustoForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['COMPLEMENTAR_CENTRO_DISTRIBUICAO_GERENCIAR'])) return alertNotPermission();

    return (
        <FormProvider>
            <CentroCustoFormComp />
        </FormProvider>
    );
}
